import { avatar14, img15, img16, img17, img18 } from "../../_components/Imagepath";

export default {
  IncomeData: [
    {
      id: 1,

      image: avatar14,
      name: "Orn LLC",
      email: "orn@example.com",

      "date": "20 Sep 2023",
    "amount": "$2000.00",
    "paymentMethod": "Cash"
    },
    {
      id: 2,

      image: img15,
      name: "Accent Technology",
      email: "accent@example.com",

      "date": "15 Sep 2023",
    "amount": "$0.00",
    "paymentMethod": "Cash"
    },
    {
      id: 3,

      image: img16,
      name: "Express Advertising",
      email: "express@example.com",

      "date": "10 Sep 2023",
      "amount": "$1000.00",
      "paymentMethod": "Cash"
    },
    {
      id: 4,

      image: img17,
      name: "Lexicon Technologies",
      email: "lexicon@example.com",

      "date": "05 Aug 2022",
    "amount": "$1500.00",
    "paymentMethod": "Cash"
    },
    {
      id: 5,

      image: img18,
      name: "Sumo Soft Limited",
      email: "sumo@example.com",

      "date": "01 July 2022",
    "amount": "$1000.00",
    "paymentMethod": "Cash"
    },
  ],
};
